/*
  cart-drawer-fix.js
  Safe runtime patch to:
   - Prevent cart drawer from auto-opening on the /cart page
   - Avoid the AJAX drawer template from wiping the cart page (no more '...')
   - Ensure quantity inputs remain visible (CSS fallback)
  Paste this at the end of assets/theme.js (or include as a separate asset and load after theme.js)
*/

(function () {
  'use strict';

  // If we are on the cart page, set a global flag so other code can check it.
  try {
    if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') === 0) {
      window.overrideCartDrawer = true;
    }
  } catch (e) {
    console.error('cart-drawer-fix: cannot set override flag', e);
  }

  // CSS fallback to make sure quantity inputs are visible if CSS hides them.
  (function injectCss() {
    try {
      var css = '\
/* cart-drawer-fix: force quantity inputs visible on cart page */\n.template-cart input[type=number][name="updates[]"],\n.cart-template-section input[type=number][name="updates[]"] {\n  width: 64px !important;\n  padding: 6px 8px !important;\n  font-size: 15px !important;\n  color: #000 !important;\n  border: 1px solid #ddd !important;\n  background: #fff !important;\n  border-radius: 4px !important;\n  -webkit-appearance: number-input !important;\n}\n.template-cart input[type="number"]::-webkit-inner-spin-button,\n.template-cart input[type="number"]::-webkit-outer-spin-button {\n  opacity: 1 !important;\n}\n';      var style = document.createElement('style');      style.setAttribute('data-cart-drawer-fix','1');      style.appendChild(document.createTextNode(css));      document.head.appendChild(style);    } catch (e) { console.error('cart-drawer-fix: injectCss failed', e); }
  })();

  // Utility: safe wrapper to run code after theme and drawers exist
  function runWhenThemeReady(fn) {
    var tries = 0;
    var maxTries = 50;
    var interval = setInterval(function () {
      tries++;
      if (window.theme && typeof window.theme.Drawers === 'function') {
        clearInterval(interval);
        try { fn(); } catch (e) { console.error('cart-drawer-fix:', e); }
      } else if (tries >= maxTries) {
        clearInterval(interval);
        // Still try to run once
        try { fn(); } catch (e) { console.error('cart-drawer-fix final try:', e); }
      }
    }, 140);
  }

  runWhenThemeReady(function () {
    try {
      // 1) Prevent RightDrawer from being initialized on the cart page.
      // If theme.RightDrawer already exists, we wrap its open() method.
      if (window.theme && window.theme.RightDrawer) {
        var rd = window.theme.RightDrawer;
        if (rd && typeof rd.open === 'function') {
          var originalOpen = rd.open.bind(rd);
          rd.open = function () {
            if (window.overrideCartDrawer) {
              // Do not open drawer on cart page
              return;
            }
            return originalOpen();
          };
        }
      }

      // 2) If theme.drawersInit is invoked elsewhere and will create RightDrawer,
      // ensure it's only created when overrideCartDrawer is false.
      // We monkey-patch theme.drawersInit to wrap the RightDrawer initialization.
      if (window.theme && typeof window.theme.drawersInit === 'function') {
        var origDrawersInit = window.theme.drawersInit;
        window.theme.drawersInit = function () {
          try {
            // Temporarily capture window.overrideCartDrawer
            var wasOverride = !!window.overrideCartDrawer;
            // If on cart page, keep override true so RightDrawer won't init
            if (wasOverride) {
              // call original but prevent RightDrawer creation by setting a sentinel
              // Some themes create RightDrawer using theme.Drawers - patch theme.Drawers to no-op during this call
              if (window.theme && typeof window.theme.Drawers === 'function') {
                var realDrawers = window.theme.Drawers;
                // create a noop temporary Drawers constructor
                function NoopDrawers() {}
                window.theme.Drawers = NoopDrawers;
                try {
                  origDrawersInit.apply(window.theme, arguments);
                } finally {
                  // restore constructor
                  window.theme.Drawers = realDrawers;
                }
                return;
              }
            }
            // default behavior
            return origDrawersInit.apply(window.theme, arguments);
          } catch (e) {
            console.error('cart-drawer-fix: drawersInit wrapper error', e);
            return origDrawersInit.apply(window.theme, arguments);
          }
        };
      }

      // 3) Prevent auto-opening calls like theme.RightDrawer.open() after cart updates
      // Wrap any event that calls RightDrawer.open via theme.afterCartLoad if present
      if (window.theme && typeof window.theme.afterCartLoad === 'function') {
        var origAfterCartLoad = window.theme.afterCartLoad;
        window.theme.afterCartLoad = function () {
          // call original to attach events
          origAfterCartLoad.apply(window.theme, arguments);
          // then find event handler and patch RightDrawer.open inside it (best-effort)
          try {
            if (window.theme && window.theme.RightDrawer && typeof window.theme.RightDrawer.open === 'function') {
              var rd2 = window.theme.RightDrawer;
              var origOpen2 = rd2.open.bind(rd2);
              rd2.open = function () {
                if (window.overrideCartDrawer) return;
                return origOpen2();
              };
            }
          } catch (e) { /* ignore */ }
        };
      }

      // 4) Ensure ajaxCart.load does not overwrite cart page content when on /cart
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        var origAjaxLoad = window.ajaxCart.load.bind(window.ajaxCart);
        window.ajaxCart.load = function () {
          if (window.overrideCartDrawer) {
            // If on cart page - do not run drawer-specific loader
            return;
          }
          return origAjaxLoad.apply(null, arguments);
        };
      }

      // 5) MutationObserver safety: If something replaces quantity inputs with '...' on cart page,
      // restore a simple number input so the user can change values.
      (function observeAndRestore() {
        if (!('MutationObserver' in window)) return;
        var cartRootSelectors = ['.cart', '.cart-template-section', '#CartContainer', '.template-cart'];
        var root = document.querySelector(cartRootSelectors.join(','));
        if (!root) {
          // try again later
          setTimeout(observeAndRestore, 500);
          return;
        }
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            // look for text nodes with three dots inserted or elements containing only dots
            m.addedNodes && m.addedNodes.forEach(function (node) {
              try {
                if (node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.trim() === '...') {
                  // find nearest cart row and replace with number input if possible
                  var parent = node.parentElement;
                  if (parent) {
                    var qtyInput = parent.querySelector('input[type="number"][name="updates[]"]');
                    if (!qtyInput) {
                      // create a safe input and append
                      var input = document.createElement('input');
                      input.type = 'number';
                      input.name = 'updates[]';
                      input.min = '0';
                      input.value = '1';
                      input.setAttribute('data-ajax-qty','1');
                      input.style.width = '60px';
                      parent.appendChild(input);
                    }
                    // remove the dots text node
                    parent.removeChild(node);
                  }
                } else if (node.nodeType === 1) {
                  // element node: if it contains only dots, replace
                  var txt = node.textContent && node.textContent.trim();
                  if (txt === '...') {
                    var parent = node.parentElement;
                    if (parent) {
                      var input = document.createElement('input');
                      input.type = 'number';
                      input.name = 'updates[]';
                      input.min = '0';
                      input.value = '1';
                      input.setAttribute('data-ajax-qty','1');
                      input.style.width = '60px';
                      parent.replaceChild(input, node);
                    }
                  }
                }
              } catch (e) { /* ignore */ }
            });
          });
        });
        observer.observe(root, { childList: true, subtree: true, characterData: true });
      })();

      console.log('cart-drawer-fix: runtime patch applied.');
    } catch (err) {
      console.error('cart-drawer-fix: initialization error', err);
    }
  });
})();